import { Component, Input } from '@angular/core';

import { BreadcrumbElement } from './breadcrumb-element.interface';

@Component({
  selector: 'planone-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  @Input() breadcrumbClickable = true;

  @Input()
  set breadcrumbElements(elements: BreadcrumbElement[] | undefined | null) {
    this.elements = elements?.reverse();
  }

  public elements: BreadcrumbElement[] | undefined;

  isElementDisabled(index: number): boolean {
    if (index === 0) return true;

    return this.elements ? this.elements[index].disabled ?? false : false;
  }

  identifyBreadcrumb(_index: number, breadcrumb: BreadcrumbElement): string {
    return `${breadcrumb.label}/${breadcrumb.routerLink}`;
  }
}
